export default "__VITE_ASSET__DZ13Sg7G__"